import { z } from 'zod'

import { ProErrorSchema } from 'shared/api/common/schemas/errors'
import {
  SmartSegmentFilterSchema,
  SmartSegmentSchema,
} from 'shared/api/common/schemas/smartSegments'
import { usedEntitiesListSchema } from 'shared/api/requests/cms/schemas/usedEntitiesList'

import {
  SmartSegmentFilterValidationErrorSchema,
  SmartSegmentNotFoundSchema,
  SmartSegmentTitleValidationErrorSchema,
} from './errors'

const GetSmartSegmentsListResponseSchema = z.object({
  segments: z.array(SmartSegmentSchema),
})

const DeleteSmartSegmentRequestSchema = z.object({
  smart_segment_id: z.number(),
})

const FetchSmartSegmentQuerySchema = z.object({
  smart_segment_id: z.number(),
})

const CreateSmartSegmentRequestSchema = z.object({
  title: z.string(),
  filter: SmartSegmentFilterSchema.optional(),
  description: z.string().optional(),
})

const RenameSmartSegmentRequestSchema = z.object({
  smart_segment_id: z.number(),
  name: z.string(),
})

const UpdateSmartSegmentFilterRequestSchema = z.object({
  smart_segment_id: z.number(),
  filter: SmartSegmentFilterSchema,
})

const UpdateSmartSegmentDescriptionRequestSchema = z.object({
  smart_segment_id: z.number(),
  description: z.string().nullable(),
})

const GetUsesListSmartSegmentQuerytSchema = z.object({
  smart_segment_id: z.number(),
})

export const smartSegmentApiSchemas = {
  fetch: {
    path: z.undefined(),
    query: FetchSmartSegmentQuerySchema,
    request: z.undefined(),
    response: z.object({ segment: SmartSegmentSchema }),
    errors: {
      SmartSegmentNotFound: SmartSegmentNotFoundSchema,
    },
  },
  create: {
    path: z.undefined(),
    query: z.undefined(),
    request: CreateSmartSegmentRequestSchema,
    response: z.object({ segment: SmartSegmentSchema }),
    errors: {
      GoProError: ProErrorSchema,
      FilterValidationError: SmartSegmentFilterValidationErrorSchema,
      TitleValidationError: SmartSegmentTitleValidationErrorSchema,
    },
  },
  rename: {
    path: z.undefined(),
    query: z.undefined(),
    request: RenameSmartSegmentRequestSchema,
    response: z.object({ segment: SmartSegmentSchema }),
  },
  updateFilter: {
    path: z.undefined(),
    query: z.undefined(),
    request: UpdateSmartSegmentFilterRequestSchema,
    response: z.object({ segment: SmartSegmentSchema }),
    errors: {
      GoProError: ProErrorSchema,
      FilterValidationError: SmartSegmentFilterValidationErrorSchema,
      SmartSegmentNotFound: SmartSegmentNotFoundSchema,
    },
  },
  updateDescription: {
    path: z.undefined(),
    query: z.undefined(),
    request: UpdateSmartSegmentDescriptionRequestSchema,
    response: z.object({ segment: SmartSegmentSchema }),
  },
  getUsesList: {
    path: z.undefined(),
    query: GetUsesListSmartSegmentQuerytSchema,
    request: z.undefined(),
    response: z.object({
      entities: usedEntitiesListSchema,
    }),
  },
  getList: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: GetSmartSegmentsListResponseSchema,
  },
  delete: {
    path: z.undefined(),
    query: z.undefined(),
    request: DeleteSmartSegmentRequestSchema,
    response: z.undefined(),
  },
}
export type CreateSmartSegmentRequest = z.infer<typeof CreateSmartSegmentRequestSchema>
export type RenameSmartSegmentRequest = z.infer<typeof RenameSmartSegmentRequestSchema>
export type UpdateSmartSegmentFilterRequest = z.infer<typeof UpdateSmartSegmentFilterRequestSchema>
export type UpdateSmartSegmentDescriptionRequest = z.infer<
  typeof UpdateSmartSegmentDescriptionRequestSchema
>
